export default __webpack_public_path__ + "static/media/spices.ce1363f9.jpeg";